export const vaultApyDescription =
  'Annualised percentage yield earned on deposits, including the effects of compounding.';

export const vaultTvlDescription =
  'Total value of all assets currently deposited in this vault.';

export const vaultCollateralizationDescription =
  'Total account value divided by outstanding depositor obligations. Above 100% means the vault can cover all depositor claims.';

export const vaultMarginRatioDescription =
  "Maintenance margin divided by balance. When the margin ratio reaches 100% the vault's positions will be liquidated.";

export const vaultDepositorObligationsDescription =
  "Total value owed to all depositors, including accrued interest. Excludes the manager's holdings.";

export const vaultYourBalanceDescription =
  'Your current vault balance, inclusive of accrued interest or profit share, net of fees.';

export const vaultManagerWithdrawalImpactLiquidationNoticeText =
  'Withdrawing funds may impact the liquidation price of open positions.';

export const vaultManagerWithdrawalReducesMarginNoticeText =
  "This withdrawal reduces the vault's margin of safety relative to the Exit Threshold.";

export const vaultStargateBridgeFeeDescription =
  'Fee charged by the Stargate protocol for cross-chain transfer of withdrawn funds. Varies by network conditions and destination chain.';

export const vaultFeeDescription =
  'Fee applied to deposits or withdrawals as defined by the vault manager.';

export const vaultDepositorWithdrawalRateNoticeText =
  "Withdrawals from this vault are rate-limited. Review the vault's withdrawal rate and period before depositing.";

export const vaultDepositorLegalDisclaimerText =
  'Participating in vaults involves inherent risks including partial or complete loss of funds. Past performance does not guarantee future results. By proceeding, you acknowledge these risks and agree that Katana bears no liability for losses incurred.';

export const vaultDepositFromExchangeImpactLiquidationNoticeText =
  'Depositing from your exchange balance may impact the liquidation price of open positions on your exchange account.';

export const vaultWithdrawalMayBeQueuedNoticeText =
  "If this withdrawal exceeds the vault's available collateral, it will be queued and processed when liquidity becomes available.";

export const vaultWithdrawalWillBeQueuedNoticeText =
  'There are pending withdrawals in the queue. This withdrawal will be queued behind them and processed sequentially when liquidity becomes available.';

export const vaultDepositsCapDescription =
  'Net deposits (total deposits minus total withdrawals) relative to the manager-defined deposit cap.';

export const vaultWithdrawalThresholdDescription =
  'Time window after which a depositor with an unserviced withdrawal may force the withdrawal directly via the vault contract.';

export const vaultWithdrawalRequestsDescription =
  'Withdrawal requests are queued on-chain and processed sequentially up to available collateral.';

export const vaultExitThresholdDescription =
  "If the vault's exit value falls below this percentage of depositor obligations, any depositor may initiate a vault exit.";

export const vaultExitValueDescription =
  'Estimated recoverable value if all positions were closed at current market prices.';

export const vaultPendingConfigurationText = (effectiveDateTime?: string) =>
  effectiveDateTime
    ? `A configuration update has been initiated and will take effect after ${effectiveDateTime}.`
    : 'A configuration update has been initiated and will take effect after the governance delay period.';

export const vaultExchangeActivityPublicNoticeText =
  'All previous exchange activity on this wallet will become publicly visible. Use a new wallet for privacy.';

export const vaultFundsWithdrawableToThresholdNoticeText =
  'Funds may only be withdrawn down to the Withdrawal Threshold.';

export const vaultManagerLegalDisclaimerText =
  "By creating a vault, you accept sole responsibility for all trading activity within this account. Vault performance is publicly visible and depositor funds are subject to the vault's configuration terms. You are responsible for maintaining adequate collateral and servicing withdrawals in a timely manner.";

export const vaultConfigurationDescription =
  'Parameters governing vault operation: yield rates, deposit caps, fees, and withdrawal limits. These may be updated after creation, subject to the governance delay.';

export const vaultCreationFeeDescription = (formattedFee: string) =>
  `A one-time ${formattedFee} creation fee, deducted from your initial deposit.`;

export const vaultCreationAlreadyManagingTooltipText =
  'Your wallet is already managing a vault.';

export const vaultCreationRequiresEmptyWalletTooltipText =
  'Vault creation requires an empty wallet without any balance or open positions.';

export const vaultCreationPendingDepositTooltipText =
  'Vault creation is not available while your wallet has a pending deposit.';
